import React,{ useEffect, useState, useReducer} from "react";

const IndividualPrices = (props)=>{

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE':
				return { ...state, [action.k]:action.v };

			default:
				return state;
		}
	}, {
		type:false,
		display_calculator:false,
		message_type:'',
		months:false,
		app:false,
	});


    const labels = props?.labels || {};

    useEffect(()=>{
        $('#type').selectric().on('change', (e) => {
            let element = e.target;
            dispatch({type:'CHANGE',k:'type',v:element.value});
            $('#months').val(1);
            dispatch({type:'CHANGE',k:'months',v:1});
            setValues(element.value);
          });
     
    },[state.type]);

    useEffect(()=>{
        if(state.months != false){
            $('#months').selectric().on('change', (e) => {
                let element = e.target;
                dispatch({type:'CHANGE',k:'months',v:element.value});
              });
        }
    },[state.months]);

    const setValues = (type) => {
        var app_arr = type.split("__");
		var app = app_arr[1];
		var application = props.promo_types[app];
		var display_calculator = true;
		var _message_type = '';

		switch(application.id) {
			case 's2':
			case 's3':
			case 's4':
			case 's5':
			case 's6':
			case 's8':
				display_calculator = false;
				_message_type = 'basic';
				break;
			case 's7':
			case 's9':
				display_calculator = false;
				_message_type = 'basicpro';
				break;
			case '31':
			case '32':
			case '33':
			case '35':
			case '36':
			case '42':
			case '46':
				display_calculator = false;
				_message_type = 'whitelabel';
				break;
            case '44':
            case '45':
            case '52':
            case '53':
            case '55':
            case '56':
            case '58':
                display_calculator = false;
                _message_type = 'premium';
                break;
			default:
                if(application.in_group == "multi"){
                    display_calculator = false;
                    _message_type = 'whitelabel';
                }
				break;
		}

        dispatch({type:'CHANGE',k:'display_calculator',v:display_calculator});
        dispatch({type:'CHANGE',k:'message_type',v:_message_type});
        dispatch({type:'CHANGE',k:'months',v:display_calculator ? 1 : false});
        dispatch({type:'CHANGE',k:'app',v:app});
    }

    let month_selector = [];
    for (let month = 1; month <= 12; month++) {
        let label = month + ' ' + (month > 1 ? labels['more_months'] : labels['one_month']);
        month_selector.push({month,label});
    }

    let prices,basic_props,premium_props,wl_props;

    if(state.months > 0 && state.app) {
        prices = {
            basic:props.preu['basic']['ud']['preu_'+(props.show_prices_in_euros ? 'euro' : 'dolar')] * state.months,
            premium:props.preu['premium']['ud']['preu_'+(props.show_prices_in_euros ? 'euro' : 'dolar')] * state.months,
            whitelabel:props.preu['whitelabel']['ud']['preu_'+(props.show_prices_in_euros ? 'euro' : 'dolar')] * state.months,
        };

        basic_props = props.info_versions[state.app].basic || {};
        premium_props = props.info_versions[state.app].premium || {};
        wl_props = props.info_versions[state.app].wl || {};
    }

    return (
        <div class="container">
            <div class="intro-block mb-3">
                <h2 class="tit-6 w-700 clr-dark txt-caps">{labels['title']+':'}</h2>
            </div>
            <div class="split-row">
                <div class="col form-group">
                    <label for="type" class="form-label txt-6 w-500 clr-dark">{labels['type']}</label>
                    <select id="type" name="type" class="form-control form-select">
                        <option value="">{" -- " +labels['type_option'] + " -- "}</option>
                        {props.main_selector && props.main_selector.length > 0 && props.main_selector.map((e, key) => {
                            return <optgroup key={e.id} label={e.nom}>
                                {e.values.map((project,projectKey) => {
                                    return <option key={projectKey} value={project.id}>{project.nom}</option>
                                })}
                            </optgroup>;
                        })}
                    </select>
                </div>
                
                {(state.months != false) && (
                    <div class="col form-group">
                        <label for="months" class="form-label txt-6 w-500 clr-dark">{labels['months']}</label>
                        <select id="months" name="months" class="form-control form-select">
                            {month_selector.map((e, key) => {
                                return <option key={e.month} value={e.month}>{e.label}</option>
                            })}
                        </select>
                    </div>
                )}
            </div>
            {(state.display_calculator) ? (
                <div class="mt-3">
                    <div class="msg-alert">
                        <h5 class="clr-dark tit-6 mb-3 txt-caps">{labels['available']+': '}</h5>
                        {(basic_props?.status || false) && (
                            <div class="txt-5 mt-3 is-plan-basic">
                                <strong>
                                    {labels['version']+': '}
                                    <span class="btn btn-tag mx-3">
                                        <span class="txt clr-white">{basic_props.name}</span> 
                                    </span>
                                    <span class="w-700 clr-dark">{labels['total_price']+': '} {props.show_prices_in_euros ? prices.basic +'€': '$'+prices.basic+'USD'}</span>
                                    <span class="clr-dark mx-1">({labels['vat_not_included']})</span>
                                </strong> 
                            </div>
                        )}
                        {(premium_props?.status || false) && (
                            <div class="txt-5 mt-3 is-plan-premium">
                                <strong class="mr-3">
                                    {labels['version']+':'}
                                    <span class="btn btn-tag mx-3">
                                        <span class="txt clr-dark">{premium_props.name}</span> 
                                    </span>
                                    <span class="w-700 clr-dark">{labels['total_price']+': '} {props.show_prices_in_euros ? prices.premium +'€': '$'+prices.premium+'USD'}</span>
                                    <span class="clr-dark mx-1">({labels['vat_not_included']})</span>
                                </strong>
                            </div>
                        )}
                        {(wl_props?.status || false) && (
                            <>
                            <div class="txt-5 mt-3 is-plan-white-label">
                                <strong>
                                    {labels['version']+': '}
                                    <span class="btn btn-tag mx-3">
                                        <span class="txt clr-white">{wl_props.name}</span> 
                                    </span>
                                    <span class="w-700 clr-dark">{labels['total_price']+': '} {props.show_prices_in_euros ? prices.whitelabel +'€': '$'+prices.whitelabel+'USD'}</span>
                                    <span class="clr-dark mx-1">({labels['vat_not_included']})</span>
                                </strong> 
                            </div>
                            <p class="clr-dark txt-7 mt-4 w-700">{labels['whitelabel_txt0']+': '}</p>
                            <p class="clr-dark txt-7 mt-1">{labels['whitelabel_txt1']} <span class="w-900">{labels['whitelabel_txt2']}</span></p>
                            </>
                        )}
                        {(props.promo_types[state.app] != undefined) && (
                            <a href={props.base_url+'?utm_content='+props.promo_types[state.app].utm_content} class="btn bg-primary btn-s mt-4">{labels['start_now']}</a>
                        )}
                    </div>
                </div>
            ): (
                (state.app) && (
                    <>
                        <p class="txt-5 mt-1" dangerouslySetInnerHTML={{__html: labels['giveaway_'+state.message_type]}}/>
                        <p class="txt-5 mt-1">{labels['giveaway_label']}</p>
                        <a href={props.info_versions[state.app].basic.mr+'/#pricetypes'} class="btn bg-primary btn-s mt-4">{labels['see_plans']}</a>
                    </>
                )
            )}
        </div>
    )
}

export default IndividualPrices;